import { fetchStream } from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import readAssistantStream from "ai/hooks/readAssistantStream";
const URL = "/plugins/org.graylog.plugins.assistant/assistant";
const streamAssistantRequest = async (request, onToolEvent, signal) => {
  var _a, _b;
  const body = await fetchStream("POST", qualifyUrl(URL), request, signal);
  const ending = {};
  await readAssistantStream(body.getReader(), (event) => {
    if (event.type === "answer" || event.type === "error") {
      ending.event = event;
    } else {
      onToolEvent(event);
    }
  });
  if (((_a = ending.event) == null ? void 0 : _a.type) === "answer") {
    return { text: ending.event.text };
  }
  throw new Error(((_b = ending.event) == null ? void 0 : _b.type) === "error" ? ending.event.message : "The assistant stopped before it finished.");
};
export default streamAssistantRequest;
